<template>
  <div class="custom-border-outline mt-3">
    <div class="d-flex justify-content-between flex-wrap align-items-center">
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
        {{ $t('iframe.titles.project_styles') }}
      </h5>

      <i
        v-if="collapsable"
        class="clickable p-3"
        :class="{'fa fa-chevron-up': !isCollapsed, 'fa fa-chevron-down': isCollapsed}"
        @click="isCollapsed = !isCollapsed"
      >
      </i>
    </div>

    <div v-if="!isCollapsed">
      <form class="evollu-form">
        <h6 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.titles.typography') }}
        </h6>

        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- input name -->
          <div class="row col-md-6 ml-0">
            <div class="col-12">
              <va-input
                id="textSize"
                type="number"
                v-model.number="value.text_size"
                :label="$t('iframe.titles.text_size')"
                :placeholder="$t('iframe.titles.text_size')"
                @input="formErrors.clear('text_size')"
              />

              <small v-show="formErrors.has('text_size')" class="help text-danger">
                {{ $t(formErrors.get('text_size')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <h6 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.titles.logos') }}
        </h6>
        <div class="row col-12" style="margin-bottom: 0 !important;">

          <div class="row col-md-6">
            <div class="col-12">
              <label class="form-label">{{ $t('iframe.titles.logo_1') }}</label>
              <multiselect
                :options="filteredLogosOptions"
                v-model="selectedLogos[0]"
                :multiple="false"
                :allow-empty="true"
                track-by="id"
                open-direction="bottom"
                :searchable="true"
                :placeholder="$t('iframe.titles.logo_1')"
                @input="formErrors.clear('logos')"
              >
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="selectedLogos[0]"
                       @mousedown.prevent.stop="handleClearLogo(0)"></div>
                </template>
                <template slot="singleLabel" slot-scope="{ option }">
                  <img class="option__image" width="60px" :src="option.logo" alt="Sth"/>
                  <span class="option__desc">
              <span class="option__title"> --- {{ option.name }}</span>
            </span>
                </template>

                <template slot="option" slot-scope="{ option }">
                  <img class="option__image" width="60px" :src="option.logo" alt="Sth"/>
                  <span class="option__desc">
            <span class="option__title"> --- {{ option.name }}</span>
            </span>
                </template>

              </multiselect>
            </div>
          </div>

          <div class="row col-md-6">
            <div class="col-12">
              <label class="form-label">{{ $t('iframe.titles.logo_2') }}</label>
              <multiselect
                :options="filteredLogosOptions"
                v-model="selectedLogos[1]"
                :multiple="false"
                :allow-empty="true"
                track-by="id"
                open-direction="bottom"
                :searchable="true"
                :placeholder="$t('iframe.titles.logo_2')"
                :disabled="selectedLogos.length === 0"
                @input="formErrors.clear('logos')"
              >
                <template slot="clear" slot-scope="props">
                  <div class="multiselect__clear" v-if="selectedLogos[1]"
                       @mousedown.prevent.stop="handleClearLogo(1)"></div>
                </template>
                <template slot="singleLabel" slot-scope="{ option }">
                  <img class="option__image" width="60px" :src="option.logo" alt="Sth"/>
                  <span class="option__desc">
              <span class="option__title"> --- {{ option.name }}</span>
            </span>
                </template>

                <template slot="option" slot-scope="{ option }">
                  <img class="option__image" width="60px" :src="option.logo" alt="Sth"/>
                  <span class="option__desc">
            <span class="option__title"> --- {{ option.name }}</span>
            </span>
                </template>

              </multiselect>
            </div>
          </div>

          <small v-show="formErrors.has('logos')" class="help text-danger pl-3">
            {{ $t(formErrors.get('logos')) }}
          </small>
        </div>

        <h6 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.titles.color_palette') }}
        </h6>
        <div class="row col-12" style="margin-bottom: 0 !important;">
          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorPrimary"
                type="color"
                v-model="value.primary"
                :label="$t('iframe.titles.color_primary')"
                :placeholder="$t('iframe.titles.color_primary')"
                @input="formErrors.clear('colors_primary')"
              />
              <small v-show="formErrors.has('colors_primary')" class="help text-danger">
                {{ $t(formErrors.get('colors_primary')) }}
              </small>
            </div>
          </div>

          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorPrimaryDark20"
                type="color"
                v-model="value.primary_dark_20"
                :label="$t('iframe.titles.color_primary_dark_20')"
                :placeholder="$t('iframe.titles.color_primary_dark_20')"
                @input="formErrors.clear('colors_primary_dark20')"
              />
              <small v-show="formErrors.has('colors_primary_dark20')" class="help text-danger">
                {{ $t(formErrors.get('colors_primary_dark20')) }}
              </small>
            </div>
          </div>

          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorPrimaryDark40"
                type="color"
                v-model="value.primary_dark_40"
                :label="$t('iframe.titles.color_primary_dark_40')"
                :placeholder="$t('iframe.titles.color_primary_dark_40')"
                @input="formErrors.clear('colors_primary_dark40')"
              />
              <small v-show="formErrors.has('colors_primary_dark40')" class="help text-danger">
                {{ $t(formErrors.get('colors_primary_dark40')) }}
              </small>
            </div>
          </div>

          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorPrimaryDark50"
                type="color"
                v-model="value.primary_dark_50"
                :label="$t('iframe.titles.color_primary_dark_50')"
                :placeholder="$t('iframe.titles.color_primary_dark_50')"
                @input="formErrors.clear('colors_primary_dark50')"
              />
              <small v-show="formErrors.has('colors_primary_dark50')" class="help text-danger">
                {{ $t(formErrors.get('colors_primary_dark50')) }}
              </small>
            </div>
          </div>
        </div>
        <div class="row col-12" style="margin-bottom: 0 !important;">
          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorSecondary"
                type="color"
                v-model="value.secondary"
                :label="$t('iframe.titles.color_secondary')"
                :placeholder="$t('iframe.titles.color_secondary')"
                @input="formErrors.clear('colors_secondary')"
              />
              <small v-show="formErrors.has('colors_secondary')" class="help text-danger">
                {{ $t(formErrors.get('colors_secondary')) }}
              </small>
            </div>
          </div>

          <div class="row col-md-3 ml-0 mr-0">
            <div class="col-12">
              <va-input
                id="colorSecondaryLight20"
                type="color"
                v-model="value.secondary_light_20"
                :label="$t('iframe.titles.color_secondary_light_20')"
                :placeholder="$t('iframe.titles.color_secondary_light_20')"
                @input="formErrors.clear('colors_secondary_light20')"
              />
              <small v-show="formErrors.has('colors_secondary_light20')" class="help text-danger">
                {{ $t(formErrors.get('colors_secondary_light20')) }}
              </small>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import {IframeService} from "@/api/IframeService";
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      required: true,
      default: () => {}
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data: function () {
    return {
      isCollapsed: this.collapsable && this.collapsed,
      logosOptions: [],
      filteredLogosOptions: [],
      selectedLogos: []
    }
  },
  mounted() {
    this.getLogos()

  },
  methods: {
    handleClearLogo(idx) {
      if (idx === 0 && this.selectedLogos && this.selectedLogos.length > 1) {
        this.selectedLogos[0] = this.selectedLogos[1]
        this.selectedLogos.pop()
      } else {
        this.selectedLogos.pop()
      }
    },
    getLogos: function () {
      IframeService.getAllLogos()
        .then(res => {
          this.logosOptions = res.data.items

          const flowLogosStrSplitted = this.value.logos.map(item => item.split("/"))
          const flowLogosIds = flowLogosStrSplitted.map(item => item[item.length - 1])
          this.selectedLogos = this.logosOptions.filter(item => flowLogosIds.includes(item.id) && item.client_id === this.client.id)
          this.filteredLogosOptions = this.selectedLogos
        })
        .catch(err => {
          console.log("ERROR GETTING LOGOS")
          console.log(err)
        })
    }
  },
  computed: {},
  watch: {
    selectedLogos() {
      const selectedLogosIds = this.selectedLogos.map(elem => elem.id)
      this.filteredLogosOptions = this.logosOptions.filter(elem => !selectedLogosIds.includes(elem.id) && elem.client_id === this.client.id)
      //this.filteredLogosOptions = this.logosOptions.filter(elem => elem.client_id === this.client.id)
    },
    'client': function(val) {
      this.selectedLogos = []
    }
  }
}
</script>

<style>
#colorPrimary, #colorPrimaryDark20, #colorPrimaryDark40, #colorPrimaryDark50, #colorSecondary, #colorSecondaryLight20 {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;

}</style>
<style scoped>
.evollu-form .row {
  margin: 0 0 1.25rem !important;
}

.add-icon-wh {
  width: 2.5rem;
  height: 2.5rem;
}

.verical-line {
  width: 3px;
  height: 33px;
  background: #8E99B4;
  border-radius: 1.5px;
  align-self: center;
  margin: 0 10px;
  display: flex;
}

.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}

.upload-div {
  display: flex;
  font-size: 12px;
  background: #EAEAEA;
  border: 2px dashed rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}
</style>
